import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Loader from './components/shared/Loader';
import LoginContainer from './components/shared/users/LoginContainer';
import Register from './components/shared/users/Register';
import Profile from './components/shared/users/Profile';
import AdminLogin from './components/admin/AdminLogin';
import PrivateRoute from './components/shared/PrivateRoute';
import Dashboard from './components/admin/Dashboard';
import Orders from './components/admin/Orders';
import Inicio from './components/client/Inicio';
import ProductList from './components/client/ProductList';
import SingleProduct from './components/client/SingleProduct';
import ProductoAIList from './components/client/ProductoAIList';
import Cart from './components/client/Cart';
import Checkout from './components/client/Checkout';
import OrderSuccess from './components/client/OrderSuccess';
import OrderFailure from './components/client/OrderFailure';
import OrderPending from './components/client/OrderPending';
import CustomizableProductList from './components/client/CustomizableProductList';
import CustomizableProductPage from './components/client/CustomizableProductPage';
import PersonalizadosLanding from './components/client/PersonalizadosLanding';
import MerchandisingPage from './components/client/MerchandisingPage';
import Menu from './components/client/Menu';
import AIProductsQuickAccess from './components/client/AIProductsQuickAccess';
import Footer from './components/client/Footer';
import ChatWidget from './components/shared/ChatWidget';
import GlobalTypography from './components/shared/GlobalTypography';
import GlobalColors from './components/shared/GlobalColors';
import MaintenancePage from './components/shared/MaintenancePage';
import PromoPopup from './components/shared/PromoPopup';
import { AuthContext } from './providers/AuthContext';
import { CategoryProvider } from './providers/CategoryContext';
import { QuantityPricingProvider } from './providers/QuantityPricingContext';
import { SettingsProvider, useSettings } from './providers/SettingsContext';
import ScrollToTop from './components/shared/ScrollToTop';

function AppInner() {
  const { user, loading, isAdminAuthenticated } = useContext(AuthContext);
  const { settings } = useSettings();

  // Esperamos a que Firebase confirme el estado
  if (loading) return <Loader />;

  if (settings?.maintenanceMode?.isEnabled && !isAdminAuthenticated) {
    return <MaintenancePage />;
  }

  return (
    <CategoryProvider>
      <QuantityPricingProvider>
      <Router>
        <GlobalTypography />
        <GlobalColors />
        <ScrollToTop />
        <Menu isAdminAuthenticated={isAdminAuthenticated} />
        <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/tienda" element={<ProductList />} />
        <Route path="/productoai/:clientId" element={<ProductoAIList />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/product/:id" element={<SingleProduct />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/success" element={<OrderSuccess />} />
        <Route path="/failure" element={<OrderFailure />} />
        <Route path="/pending" element={<OrderPending />} />
        <Route path="/personalizados" element={<PersonalizadosLanding />} />
        <Route path="/personalizados/ia" element={<CustomizableProductList />} />
        <Route path="/personalizado/:id" element={<CustomizableProductPage />} />
        <Route path="/merchandising" element={<MerchandisingPage />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Usuarios */}
        <Route path="/user" element={<LoginContainer />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/profile"
          element={user ? <Profile /> : <Navigate to="/user" replace />}
        />

        {/* Rutas protegidas Admin */}
        <Route element={<PrivateRoute isAuthenticated={isAdminAuthenticated} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/orders" element={<Orders />} />
        </Route>
        </Routes>
        <Footer />
        <AIProductsQuickAccess user={user} />
        <ChatWidget />
        <PromoPopup />
      </Router>
      </QuantityPricingProvider>
    </CategoryProvider>
  );
}

function App() {
  return (
    <SettingsProvider>
      <AppInner />
    </SettingsProvider>
  );
}

export default App;
